// (function() {
//     const sliderContainer = document.querySelector('.vitamin-slider__slider-container');
//     if (!sliderContainer) return;

//     const sliderTrack = sliderContainer.querySelector('.vitamin-slider__slider');
//     const slides = sliderTrack.querySelectorAll('.vitamin-slider__slide');
    
//     const dots = sliderContainer.querySelectorAll('.vitamin-slider__dot');

//     dots.forEach(dot => {
//       dot.removeAttribute('onclick');
//     });

//     let currentSlideIndex = 0;

//     function goToSlide(index) {
//       if (index < 0 || index >= slides.length) return;
      
//       sliderTrack.style.transform = 'translateX(-' + (index * 100) + '%)';
      
//       dots.forEach((dot, i) => {
//         if (i === index) {
//           dot.classList.add('vitamin-slider__active');
//         } else {
//           dot.classList.remove('vitamin-slider__active');
//         }
//       });
      
//       currentSlideIndex = index;
//     }

//     dots.forEach((dot, index) => {
//       dot.addEventListener('click', () => {
//         goToSlide(index);
//       });
//     });

//     goToSlide(0);
//   })();

(function() {
    const sliderContainer = document.querySelector('.vitamin-slider__slider-container');
    if (!sliderContainer) return;

    const sliderTrack = sliderContainer.querySelector('.vitamin-slider__slider');
    const slides = sliderTrack.querySelectorAll('.vitamin-slider__slide');
    const dots = sliderContainer.querySelectorAll('.vitamin-slider__dot');

    dots.forEach(dot => {
      dot.removeAttribute('onclick');
    });

    let currentSlideIndex = 0;

    function goToSlide(index) {
      if (index < 0 || index >= slides.length) return;
      
      sliderTrack.style.transform = 'translateX(-' + (index * 100) + '%)';
      
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('vitamin-slider__active');
        } else {
          dot.classList.remove('vitamin-slider__active');
        }
      });
      
      currentSlideIndex = index;
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
      });
    });

    let touchstartX = 0;
    let touchendX = 0;
    const swipeThreshold = 50;

    sliderContainer.addEventListener('touchstart', function(event) {
      touchstartX = event.changedTouches[0].screenX;
    }, false);

    sliderContainer.addEventListener('touchend', function(event) {
      touchendX = event.changedTouches[0].screenX;
      handleSwipe();
    }, false);

    function handleSwipe() {
      const diff = touchstartX - touchendX;
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          if (currentSlideIndex < slides.length - 1) {
            goToSlide(currentSlideIndex + 1);
          }
        } else {
          if (currentSlideIndex > 0) {
            goToSlide(currentSlideIndex - 1);
          }
        }
      }
    }

    goToSlide(0);
})();